import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import Loader from './Loader';
import { Col, Container, Row } from 'react-bootstrap';

function Layout({ children }) {
  return (
    // <div className='grid' style={{ maxWidth: '1300px', marginLeft: '100px' }}>
    <div className='grid'>
      <Loader />
      <Header />
      <Container>
        <Row>
          <Col>
            {children}
          </Col>
        </Row>
      </Container>
      <Footer />
    </div>
  );
};

export default Layout;